import { MantineProvider } from '@mantine/core'
import { useTheme } from '@v2/domains/ui/hooks/useTheme.hook'
import React from 'react'

const ThemeProviderAdapter: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const { getMantineThemeConfig } = useTheme()
  const { theme, cssVariablesResolver } = getMantineThemeConfig()

  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={cssVariablesResolver}
      withGlobalClasses
    >
      {children}
    </MantineProvider>
  )
}

export default ThemeProviderAdapter
